import "../scss/main.scss";

(function ($) {
    $(document).ready(function () {
        theme.init();
    });

    var theme = {
        init: function () {
            this.xhr = null;
            this.salesmanXhr = null;
            this.openMenu();
            this.sliderHome();
            this.initAOS();
            this.buttonsPlusMinus();
            this.productTabs();
            this.addToCart();
            this.loadMoreProducts();
            this.loadMoreBlogPosts();
            this.beforeAfter();
            this.productsSlider();
            this.filterLocations();
            this.openMobileMenu();
            this.mapLocatorOverlay();
            this.openAccordion();
            this.beforeAfterMobileSlider();
            this.checkoutCartRefresh();
            this.calendarNav();
            this.calendarReloadTrigger();
            this.calendarEventExpand();
            this.salesmanForm();
        },

        salesmanForm: function () {
            const _this = this;
            $(document).on("submit", "#salesman-form", function (e) {
                e.preventDefault();
                const form = $(this);
                const widget = $("#salesman-widget");
                let formData = new FormData(form[0]);
                formData.append("action", "salesman_search");

                _this.salesmanXhr = $.ajax({
                    url: estgen.ajaxurl,
                    method: "POST",
                    processData: false,
                    contentType: false,
                    beforeSend: function () {
                        if (_this.salesmanXhr) {
                            _this.salesmanXhr.abort();
                        }
                        widget.block({ message: "" });
                    },
                    data: formData,
                    success: function (response) {
                        widget.unblock();
                        if (response.results) {
                            $("#salesman-results").html(response.results);
                        }
                    },
                });
            });
        },

        calendarEventExpand: function () {
            $(document).on("click", "[data-calendar_expand]", function (e) {
                e.preventDefault();
                const event = $(this).closest("[data-calendar_event]");
                event.toggleClass("event-expanded");
            });
        },

        calendarReloadTrigger: function () {
            const _this = this;
            $(document).on("click", "[data-calendar_set_date]", function (e) {
                $("[data-calendar_set_date]").removeClass("calendar-nav-item--current");
                e.preventDefault();
                const date = $(this).data("calendar_set_date");
                $(this).addClass("calendar-nav-item--current");
                _this.reloadCalendar(date);
            });
        },

        reloadCalendar: function (date) {
            const _this = this;
            let wrapper = $("[data-calendar_grid]");
            wrapper.addClass("is-loading");
            this.xhr = $.ajax({
                url: estgen.ajaxurl,
                method: "POST",
                beforeSend: function () {
                    if (_this.xhr) {
                        _this.xhr.abort();
                    }
                },
                data: {
                    action: "estgen_get_calendar",
                    date: date,
                },
                success: function (response) {
                    if (response.status == 1) {
                        wrapper.html(response.html);
                        $("html, body").animate(
                            {
                                scrollTop: wrapper.offset().top - 300,
                            },
                            500,
                        );
                    }
                    wrapper.removeClass("is-loading");
                },
            });
        },

        calendarNav: function () {
            $("[data-calendar_nav]").slick({
                arrows: true,
                dots: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: $("#calendar-arrow-left"),
                nextArrow: $("#calendar-arrow-right"),
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 2.3,
                            swipeToSlide: true,
                        },
                    },
                ],
            });
        },

        checkoutCartRefresh: function () {
            $(document.body).on("updated_shipping_method", function () {
                $("form.checkout").trigger("update");

                //$('form.checkout').trigger('update');
                //  $(document.body).trigger('update_checkout');
            });
        },

        beforeAfterMobileSlider: function () {
            if (window.matchMedia("(max-width: 991px)").matches) {
                $(".before-after-slider").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    autoplay: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    dots: false,
                });
            }
        },

        openAccordion: function () {
            $(".open-mobile").click(function () {
                $(this).parent().toggleClass("open");
            });
        },

        mapLocatorOverlay: function () {
            $(document).on("click", ".map-locator-overlay a", function (e) {
                e.preventDefault();
                $(this).closest(".map-locator-overlay").remove();
            });
        },

        openMobileMenu: function () {
            $(".menu-toggle").click(function () {
                $(".menu-mobile").toggleClass("open");
            });
        },

        filterLocations: function () {
            $(document).on("cprolocator/markerschanged", function (e) {
                var visibleIds = e.originalEvent.customData.visibleMarkerIds;
                $("[data-location_id]").hide();
                visibleIds.forEach((element) => {
                    $(`[data-location_id="${element}"]`).show();
                });
            });
        },

        productsSlider: function () {
            $(".related-product-container .products.columns-4").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 3000,
                speed: 500,
                dots: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
            $(".slider-products .products").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 3000,
                speed: 500,
                dots: false,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
            $(".slider-products-post .products").slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 3000,
                speed: 500,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                        },
                    },
                ],
            });
        },

        beforeAfter: function () {
            $(".ba-slider").each(function () {
                $(this).beforeAfter();
            });
        },

        loadMoreProducts: function () {
            $(document).on("click", "[data-load_more_products]", function (e) {
                var list = $(".products.columns-4, .products.columns-5");
                var container = $(".archive .site-main");
                e.preventDefault();
                var button = $(this);
                button.remove();
                var page = button.data("load_more_products");
                container.block({
                    message: "",
                });
                $.ajax({
                    url: estgen.ajaxurl,
                    method: "POST",
                    dataType: "json",
                    data: {
                        action: "estgen_products",
                        page: page,
                    },
                    success: function (response) {
                        container.unblock();
                        if (response.html) {
                            list.append(response.html);
                        }
                    },
                });
            });
        },

        loadMoreBlogPosts: function () {
            $(document).on("click", "[data-load_more_blog_posts]", function (e) {
                var list = $(".news-inner");
                e.preventDefault();
                var button = $(this);

                if (button.hasClass("disabled")) return;

                button.addClass("disabled");

                var container = button.closest(".button-czytaj-wiecej");
                container.fadeTo(300, 0);

                var page = button.data("load_more_blog_posts");

                $.ajax({
                    url: estgen.ajaxurl,
                    method: "POST",
                    dataType: "json",
                    data: {
                        action: "estgen_blog_posts",
                        page: page,
                    },
                    success: function (response) {
                        container.remove();
                        if (response.html) {
                            list.append(response.html);
                        }
                    },
                });
            });
        },

        addToCart: function () {
            $(document).on("submit", ".estgen-add-to-cart", function (e) {
                e.preventDefault();

                var form = $(this);
                var proceed = false;
                form.find('input[type="number"]').each(function () {
                    if ($(this).val() > 0) {
                        proceed = true;
                    }
                });

                if (!proceed) return;

                form.block({
                    message: "",
                });

                $.ajax({
                    url: estgen.ajaxurl,
                    method: "POST",
                    dataType: "json",
                    data: {
                        action: "estgen_add_to_cart",
                        form: form.serialize(),
                    },
                    success: function (response) {
                        if (response.status == 1) {
                            iziToast.show({
                                theme: "dark",
                                message: "Dodano wybrane produkty do koszyka",
                                backgroundColor: "#081649",
                                position: "center",
                                progressBarColor: "#4774aa",
                                timeout: 2000,
                                transitionIn: "flipInX",
                            });

                            if (response.cart_count) {
                                $(".cart-url .count").html(response.cart_count);
                            }
                        }
                        form.unblock();
                    },
                });
            });
        },

        productTabs: function () {
            $(function () {
                $("#productTab").tabs();
            });
        },

        buttonsPlusMinus: function () {
            $(document).on("click", ".button-plus", function (e) {
                var input = $(this).prev("input");
                let val = parseInt(input.val()) + 1;
                input.val(val);
            });

            $(document).on("click", ".button-minus", function (e) {
                var input = $(this).next("input");
                let val = Math.max(parseInt(input.val()) - 1, 0);
                input.val(val);
            });
        },

        initAOS: function () {
            AOS.init();
        },

        openMenu: function () {
            $("header .container .icon").click(function () {
                $("header .container .icon .menu").toggleClass("open");
                $(".menu-top").toggleClass("open");
                $("body").toggleClass("menu-open");
            });
        },

        sliderHome: function () {
            $(".slider-ini").slick({
                dots: false,
                arrows: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false,
                        },
                    },
                ],
            });
        },
    };
})(jQuery);

// function incrementValue(e) {
// 	e.preventDefault();
// 	var fieldName = jQuery(e.target).data('field');
// 	var parent = jQuery(e.target).closest('div');
// 	var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

// 	if (!isNaN(currentVal)) {
// 	  parent.find('input[name=' + fieldName + ']').val(currentVal + 1);
// 	} else {
// 	  parent.find('input[name=' + fieldName + ']').val(0);
// 	}
//   }

//   function decrementValue(e) {
// 	e.preventDefault();
// 	var fieldName = jQuery(e.target).data('field');
// 	var parent = jQuery(e.target).closest('div');
// 	var currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

// 	if (!isNaN(currentVal) && currentVal > 0) {
// 	  parent.find('input[name=' + fieldName + ']').val(currentVal - 1);
// 	} else {
// 	  parent.find('input[name=' + fieldName + ']').val(0);
// 	}
//   }
